<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card flat>
        <v-layout row wrap>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Fatura Detay</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field> -->
            <a target="_self" v-bind:href="'#/faturalar/serbestfatura/yeni'">
              <v-btn flat> <span class="hidden-sm-and-down"> Serbest Fatura Ekle </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </a>
          </v-toolbar>

          <v-tabs style="width:100%; height:100%" dark v-model="active" color="blue darken-4
" slot="extension" slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              Genel
            </v-tab>
            <v-tab-item :id="'0'" style="width:100%; height:100%;">
              <v-container fluid>
                <v-layout row="" wrap>
                  <v-flex overflow-x-hidden xs12 sm12 md6 style="padding-right:10px;">
                    <v-card color="grey lighten-4" class="white--text">
                      <v-container>
                        <v-card flat="">
                          <v-card-actions>
                            <v-layout align-center justify-center row wrap fill-height>
                              <v-flex xs12 sm12 md12>
                                <v-layout align-center justify-center row wrap fill-height>
                                  <v-progress-circular v-if="!sonucgeldi" :size="35" :width="3" color="pink"
                                    indeterminate></v-progress-circular>
                                </v-layout>
                              </v-flex>

                              <!-- <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid"
                      lazy-validation>
                      <input hidden type="file" id="file" ref="file" multiple v-on:change="handleFileUpload()" />
                    </v-form>
                    <v-btn :loading="false" :disabled="false" color="info" dark @click="addFiles()">
                      <v-icon color="white" left>attach_file</v-icon>Aktarım Dosyası Seçiniz
                    </v-btn>
                              <v-btn @click="reportbrobas()">getir</v-btn>-->
                              <v-flex v-if="!sonucgeldi" xs12 sm12 md12>
                                <v-layout align-center justify-center row wrap fill-height>

                                  <span> Faturanız Önizleme Oluşturuluyor...</span>
                                </v-layout>
                              </v-flex>
                              <!-- <span style="align:center;" id="demo2"></span> -->

                              <iframe scrolling="yes" v-show="sonucgeldi" id="denemem" src="" height="800" width="700"
                                type="application/pdf">
                              </iframe>
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-container>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-card class="white--text">
                      <v-card color="grey lighten-4" flat="">
                        <v-card-actions>
                          <v-layout row wrap>

                            <v-flex ma-2 xs12 sm12 md12>
                              <v-flex xs12 sm12 md12 style="padding-right:2px;">
                                <v-card color="#1E88E5" class="white--text">
                                  <v-layout>
                                    <v-flex xs2 sm2 md2>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="white" large="">info</v-icon>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm10 md10>

                                      <v-card-title primary-title="">

                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs12 sm3 md3>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  Cari Kod
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs12 sm9 md9>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  : {{carikod}}
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs12 sm3 md3>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  Ünvanı
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs12 sm9 md9>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  : {{unvan}}
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs12 sm3 md3>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  <div class="font-weight-bold caption  white--text  mb-1">Kredi Limiti</div>
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs12 sm9 md9>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  <div class="font-weight-bold caption  white--text  mb-1">:
                                                    {{kredilimit}} ₺ </div>
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>

                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                  <v-card-actions class="pa-3">
                                    Fatura Özet Bilgiler
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-flex>
                            </v-flex>

                            <v-flex ma-2 xs12 sm12 md12>
                              <v-flex xs12 sm12 md12 style="padding-right:2px;">
                                <v-card color="#FF5252" class="white--text">
                                  <v-layout>


                                    <v-flex xs2 sm2 md2>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="white" large="">email</v-icon>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm10 md10>

                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs12 sm10 md10>
                                              <v-text-field v-model="email" solo class="white--text" name="email" label="Email"
                                                type="text" :rules="[rules.required, rules.email]"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm2 md2>
                                              <v-layout justify-center="" fill-height="">

                                                <v-btn @click="mailgonder()" flat icon color="white">
                                                  <v-icon large>near_me</v-icon>
                                                </v-btn>
                                              </v-layout>
                                            </v-flex>

                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>

                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                  <v-card-actions class="pa-3">
                                    Faturayı mail adresine gönder
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-flex>
                            </v-flex>


                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab href='#1'>
              Fatura Detayı
            </v-tab>
            <v-tab-item :id="'1'" style="width:100%; height:100%;">
              <v-layout row="" wrap v-if="biletvarmi">

                <v-flex xs12 sm12 md12>
                  <v-card>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md9>
                          <v-layout align-center="" fill-height="">
                            <div class=" font-weight-large grey--text title ">
                              &nbsp; {{recordcount}} <span v-if="filtreticket.length>0" class=" font-weight-large red--text title ">
                                {{filtreticket.length}} adet kayıt listelendi.. </span>
                            </div>
                          </v-layout>
                        </v-flex>

                      </v-layout>

                    </v-flex>



                    <v-list two-line>
                      <template v-for="item in filtreticket">
                        <v-layout row wrap v-bind:key="item.GenelBilgileri.BiletNo">
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout justify-center="" align-center>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                          <v-flex sm12 md1>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-img :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" height="60%" width="60%"
                                    contain></v-img>
                                  <v-img v-if="item.GenelBilgileri.Acente =='A'" :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)"
                                    alt="K" height="21px" width="86px" contain></v-img>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-layout align-start justify-start row fill-height>
                              <v-card flat="">
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-layout row align-center justify-start>
                                      <v-chip v-if="item.GenelBilgileri.Status=='S' " small="" color="green" text-color="white">Satış</v-chip>
                                      <v-chip v-if="item.GenelBilgileri.Status=='Ia' " small="" color="red" text-color="white">İade</v-chip>
                                      <v-chip v-if="item.GenelBilgileri.Status=='V' " small="" color="yellow"
                                        text-color="white">Void</v-chip>
                                      <v-list-tile-title> <span class='grey-text--primary caption '>
                                          {{item.GenelBilgileri.HavaYoluKodu}} -
                                          {{item.GenelBilgileri.BiletNo}} -
                                          {{item.GenelBilgileri.UcusTipi}} </span>
                                      </v-list-tile-title>
                                    </v-layout>
                                    <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                        {{item.GenelBilgileri.YolcuAdi}}</span>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                        {{item.GenelBilgileri.MusteriKodu.Kod}}
                                        -{{item.GenelBilgileri.MusteriKodu.Unvan}} </span>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-card>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-layout align-start justify-start row fill-height>
                              <v-card flat="">
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-layout row wrap align-center="" justify-start>
                                      <v-list-tile-title>
                                        <div class="font-weight-large red--text title">
                                          {{item.TarihBilgileri.SatisTarihi}}</div>
                                      </v-list-tile-title>
                                      <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='Ia'">
                                        <div class="font-weight-large grey--text caption">
                                          İade Tarihi: <span class="font-weight-large red--text caption">

                                            {{item.TarihBilgileri.IadeTarihi}} </span>
                                        </div>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='V'">
                                        <div class="font-weight-large grey--text caption ">
                                          Void Tarihi:<span class="font-weight-large red--text caption">
                                            {{item.TarihBilgileri.IptalTarihi}} </span>
                                        </div>
                                      </v-list-tile-sub-title>
                                    </v-layout>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-card>
                            </v-layout>
                          </v-flex>

                          <v-flex class="hidden-md-and-up" xs2 sm2 md2>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout align-start="" justify-start fill-height>
                                  <v-card flat="">
                                    <v-list-tile>
                                      <v-list-tile-content style="'overflow=inherit';">
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption "> Fatura Tarihi:
                                            {{item.FaturaBilgileri.FaturaTarihi}} </div>
                                        </v-list-tile-sub-title>

                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption "> Fatura No:
                                            {{item.FaturaBilgileri.FaturaNo}}
                                          </div>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Beklemede'" class="font-weight caption ">
                                            <v-icon hide-details color="yellow" small="">access_alarm</v-icon>
                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                          </div>

                                          <div v-if="item.FaturaBilgileri.FaturaDurumu=='Alıcı Onayladı'" class="font-weight caption ">
                                            <v-icon hide-details color="green" small="">check_box</v-icon>
                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                          </div>

                                          <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Gönderildi'" class="font-weight caption ">
                                            <v-icon hide-details color="red" small="">send</v-icon>
                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                          </div>

                                        </v-list-tile-sub-title>


                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </v-card>
                                </v-layout>
                              </v-flex>

                            </v-layout>
                          </v-flex>


                          <v-flex xs12 sm4 md2>
                            <v-layout>

                              <v-flex xs12 sm6 md6>
                                <v-layout align-start="" justify-start fill-height>
                                  <v-card flat="">
                                    <v-list-tile>
                                      <v-list-tile-content style="'overflow=inherit';">
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption ">
                                            Bilet Tutarı:
                                          </div>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption ">
                                            Vergiler:
                                          </div>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption ">
                                            Servis Bedeli:
                                          </div>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption ">

                                          </div>
                                        </v-list-tile-sub-title>

                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </v-card>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm6 md6>
                                <v-layout row justify-end="" fill-height>
                                  <v-card flat="">
                                    <v-list-tile>
                                      <v-list-tile-content>
                                        <v-list-tile-sub-title>
                                          <v-layout align-center="" justify-end>
                                            <div class="font-weight caption ">
                                              {{item.TutarBilgileri.Tutar.Tutar}} ₺ </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <v-layout align-center="" justify-end="">
                                            <div class="font-weight caption ">
                                              {{item.TutarBilgileri.Vergiler}} ₺
                                            </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <v-layout align-center="" justify-end="">
                                            <div class="font-weight caption ">
                                              {{item.TutarBilgileri.ServisBedeli}}
                                              ₺
                                            </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <v-layout align-center="">
                                            <div class="font-weight caption ">

                                            </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </v-card>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <!-- <v-flex class="hidden-md-and-up" xs1 sm1 md1>
                                </v-flex> -->

                          <v-flex xs12 sm4 md1>
                            <v-layout row align-center justify-center="" fill-height="">
                              <v-card flat="">
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-layout row wrap justify-center="">
                                      <v-list-tile-title>
                                        <v-layout row wrap justify-center="">
                                          Net Tutar
                                        </v-layout>
                                      </v-list-tile-title>
                                      <v-list-tile-sub-title>
                                        <v-layout row wrap justify-end="">
                                          <div class="red--text subheading">
                                            {{item.TutarBilgileri.NetTutar.NetTutar }} ₺ </div>
                                        </v-layout>

                                      </v-list-tile-sub-title>
                                      <v-list-tile-title>
                                        <v-layout row wrap justify-center="">
                                          <div class="font-weight green--text caption ">
                                            {{item.OdemeBilgileri.SatisSekli}}
                                          </div>
                                        </v-layout>

                                      </v-list-tile-title>
                                    </v-layout>
                                  </v-list-tile-content>

                                </v-list-tile>
                              </v-card>
                            </v-layout>
                          </v-flex>

                          <v-flex sm4 md1>

                            <v-layout row align-center justify-end="">
                              <v-card flat="">
                                <v-list-tile>

                                  <v-list-tile-action>
                                    <v-layout align-center="" fill-height="" justify-end>
                                      <v-flex sm6 md6>
                                        <a v-if="item.GenelBilgileri.Status!='V'" target="_blank" v-bind:href="'#/bilet/yeni/id?' + 'isl=get&hyolukod=' + item.GenelBilgileri.HavaYoluKodu + '&biletno=' + item.GenelBilgileri.BiletNo + '&ucustipi=' + item.GenelBilgileri.UcusTipi">
                                          <v-btn icon>
                                            <v-icon x-large="" color="grey">search</v-icon>
                                          </v-btn>
                                        </a>

                                        <a v-if="item.GenelBilgileri.Status=='V'" target="_blank" v-bind:href="'#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + item.GenelBilgileri.HavaYoluKodu + '&biletno=' + item.GenelBilgileri.BiletNo + '&ucustipi=' + item.GenelBilgileri.UcusTipi">
                                          <v-btn icon>
                                            <v-icon x-large="" color="grey">search</v-icon>
                                          </v-btn>
                                        </a>
                                      </v-flex>

                                    </v-layout>

                                  </v-list-tile-action>
                                </v-list-tile>
                              </v-card>
                            </v-layout>

                          </v-flex>

                        </v-layout>
                        <v-divider :key="item.id" inset></v-divider>
                      </template>
                    </v-list>

                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>


          </v-tabs>












          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
            :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>




          <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="600px">

            <v-card color="grey lighten-2">

              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <div class="flex md12">
                    <v-layout>
                      <v-text-field hide-details="" style="padding-right:5px;" v-model="SerbestFatura.BaslangicFaturaNo"
                        label="Fatura No-1" required> </v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFatura.BitisFaturaNo" label="Fatura No-2" required>
                      </v-text-field>

                    </v-layout>
                  </div>

                  <div class="flex md12">

                    <v-autocomplete label="Hesap Kodu " v-model="SerbestFatura.Cari.Kod" clearable :loading="loading"
                      append-icon="search" :items="hesapkodu" item-text="text" cache-items="" item-value="id"
                      :search-input.sync="search"></v-autocomplete>
                  </div>
                  <div class="flex md12">
                    <v-layout>
                      <parainput style="padding-right:3px;" v-model="SerbestFatura.MinTutar" :etiket="'Min Tutar'"
                        :autocomplete="autocomplete"></parainput>

                      <parainput :name="maxtutar" v-model="SerbestFatura.MaxTutar" :etiket="'Max Tutar'" :autocomplete="autocomplete"></parainput>
                    </v-layout>
                  </div>

                  <div class="flex md12">


                    <div class="card__text grey darken-1 white--text">
                      <h3>Opsiyonlar</h3>
                    </div>

                    <v-radio-group hide-details="" v-model="SerbestFatura.FaturaTp" label="Fatura Tipi" column>
                      <v-radio label="Hepsi" value="H"> </v-radio>
                      <v-radio label="Serbest" value="S"></v-radio>
                      <v-radio label="Bilet" value="B"></v-radio>
                      <v-radio label="Coper" value="c"></v-radio>
                    </v-radio-group>

                    <v-checkbox label="Vade Tarihini Kullan" hide-details="" v-model="SerbestFatura.VadeTarihi"></v-checkbox>
                    <v-checkbox label="Sadece Bakiyesi Olan Faturaları Göster" hide-details="" v-model="SerbestFatura.Bakiyeli"></v-checkbox>
                    <v-checkbox label="Cariye Kaydedilmesi İstenmemiş Serbest Faturaları Göster" hide-details=""
                      v-model="SerbestFatura.CariyeKaydedilmeyen"></v-checkbox>
                    <v-checkbox label="Tüm Şirketler" hide-details="" v-model="tumsirketler"></v-checkbox>
                  </div>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>





    <v-dialog scrollable="" max-width="850px">
      <v-card>
        <v-card-title>E-Fatura</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <reportbrosablon ref="reportbrosablon" v-model="dizayn" dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>






  </div>


</template>


<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import axios from 'axios'
  import logoo from '../../../assets/control'



  export default {
    data() {
      return {
        headers: [{
            text: ' Fatura Seri',
            value: 'FaturaSeri',
            width: '10'
          },
          {
            text: 'Fatura No',
            value: 'Faturano',
            width: '10'
          },
          {
            text: ' Fatura Tarihi',
            value: 'FaturaTarih'
          },
          {
            text: ' Fatura Tipi',
            value: 'Tip'
          },
          {
            text: ' Vade Tarihi',
            value: 'FaturaVade'
          },
          {
            text: 'Kalan',
            value: 'Kalan'
          },
          {
            text: 'Tutar',
            value: 'Tutar'
          },
          {
            text: 'KDV',
            value: 'Kdv'
          },
          {
            text: 'Cari',
            value: 'Cari.Kod'
          }
        ],
        rules: {
          required: (value) => !!value || 'Gerekli alan.',
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Hatalı e-mail.'
          }
        },
        file: [],
        biletvarmi: false,
        filtreticket: [],
        valid: true,
        FaturaInput: {
          SirketKodu: null,
          FaturaSeri: null,
          FaturaNo: null,
          Tip: null,
          FaturaGuid: null,
          BaslangicTarih: null,
          BitisTarih: null,
        },
        email: null,
        kredilimit: 0,
        carikod: null,
        unvan: null,
        active: null,
        sonucgeldi: false,
        dizayn: null,
        vmodelpagination: false,
        serbestAdet: 0,
        coperAdet: 0,
        biletAdet: 0,
        ToplamAdetbilcopser: 0,
        kagıtAdet: 0,
        efaturaAdet: 0,
        earsivAdet: 0,
        ToplamAdetkagefatears: 0,
        toplamKDV: 0,
        ToplamMatrah: 0,
        ToplamKDVMat: 0,
        tumunuseckaldir: false,
        siralamatipi: 'InvoiceDate',

        kayitsayisi: 0,
        kayitadet: 50,
        recordcount: null,
        kayitvarmi: true,
        searchliste: null,
        listegorunum: true,
        gorunumtipi: 'list',
        tablegorunum: false,
        kayitsayisivmodel: 50,
        kayitsayisi: [{
          text: '50',
          value: 50
        }, {
          text: '100',
          value: 100
        }],
        vmodelpagination: false,
        siralamavmodel: 0,
        siralamatipiitems: [{
          text: 'Tarihe Göre Artan',
          value: 'InvoiceDate'
        }, {
          text: 'Tarihe Göre Azalan',
          value: 'InvoiceDateDesc'
        }, {
          text: 'Cariye Göre Artan',
          value: 'InvoiceCurrentCode'
        }, {
          text: 'Cariye Göre Azalan',
          value: 'InvoiceCurrentCodeDesc'
        }, {
          text: 'Tutara Göre Artan',
          value: 'InvoiceAmount'
        }, {
          text: 'Tutara Göre Azalan',
          value: 'InvoiceAmountDesc'
        }, ],

        filtreticket: [],
        indexsayisi: 10,
        pagenumber: 1,
        sayfalama: 1,
        secilenkayitlar: [],
        tooltip: false,
        el: null,
        SerbestFatura: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          BaslangicFaturaNo: null,
          BitisFaturaNo: null,
          Cari: {
            Kod: null
          },
          MinTutar: 0,
          MaxTutar: 0,
          VadeTarihi: false,
          Bakiyeli: false,
          CariyeKaydedilmeyen: false,
          FaturaTp: 'H',
          Paging: {
            SayfaNo: 1,
            VeriAdet: 50,
            SiralamaTip: 'InvoiceDate'
          }

        },
        faturadialog: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        date2yedek: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        search3: '',
        renk: 'white',
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        e6: [],
        tumsirketler: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        search: '',
        search1: '',
        cariKod: '',
        progress: false,


        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsecbit: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

        maxtutar: 'maxtutar',
        autocomplete: 'autocomplete',
        etiket: 'Max Tutar',
        dialogfatura: false,
        mintutar: 'mintutar',
        etiketmin: 'Min Tutar',

        filtre: {
          a: '',
          b: '',
          c: ''
        },
        dialogfiltre: false,
        tooltip: false,
        el: null,

      }
    },
    beforeMount: beforeMount,
    mounted() {
      // this.el = this.$refs.fab.$el
    },
    components: {
      'parainput': parainput,
      reportbrosablon
    },
    watch: {



    },
    methods: {

      addFiles() {
        this.$refs.file.click();
      },
      handleFileUpload() {
        this.file = []
        var uploadedFiles = this.$refs.file.files;

        if (uploadedFiles.length > 0) {

          for (var i = 0; i < uploadedFiles.length; i++) {
            this.file.push(uploadedFiles[i]);
          }

        } else {

        }
      },

      mailgonder() {
        var re =
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        var kont = re.test(this.email)

        if (kont == true) {
          console.log('mail file' + this.file)
          this.epostagonder(this.email)
        } else {
          this.text1 = "Hatalı Email.."
          this.snackbar = true;
        }

      },

      getImgUrl(img) {
        return logoo.logoControl(img);
      },
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      kayitcek: kayitcek,
      efaturagoster: efaturagoster,
      tarihkontrol: tarihkontrol,
      reportbrobas: reportbrobas,
      epostagonder: epostagonder,
      servishesapla: servishesapla,
      vergihesapla: vergihesapla,
      odemeseklikontrol: odemeseklikontrol
    },
  }

  function odemeseklikontrol(v) {

    if (v == "K") {
      return ("K-Kredili");
    } else if (v == "P") {
      return ("P-Peşin");
    } else if (v == "R") {
      return ("R-Kartlı");
    } else if (v == "C") {
      return ("C-Kartlı");
    } else if (v == "F") {
      return ("F-Kredi Kartlı");
    } else {
      return null;
    }
  }

  function epostagonder(kime) {

    var cred = JSON.parse(window.localStorage.getItem('credentials'));
    let formData = new FormData();

    formData.append('file', new Blob([this.file.data], {
      type: 'application/pdf'
    }), 'E-Fatura');
    formData.append('CustomerCode', cred.AnaSirketKodu)
    formData.append('Konu', 'Arkman Fatura')
    formData.append('to', kime)
    formData.append('formattedMessage', 'ilgili faturanız ekte gönderilmiştir.')
    axios.defaults.baseURL = auth.API_URL;
    axios.responseType = 'arraybuffer';
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.post(auth.API_URL + 'api/Helpers/SendEmail',
        formData, {
          headers: {
            Authorization: `Bearer ${auth.getAuthHeader()}`
          }
        }
      ).then((response) => {

        if (response.data == true) {
          this.text1 = "Mailiniz gönderildi."
          this.snackbar = true
        } else {
          this.text1 = "Mailiniz gönderilemedi. lütfen tekrar deneyin"
          this.snackbar = true
        }
      })
      .catch(function () {});
  }

  function efaturagoster(v, y) {

    var params = {
      id: y,
      guid: v
    }

    this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function reportbrobas(v, y, dizaynkod) {


    this.dizayn = dizaynkod;
    var prm = {
      id: y,
      guid: v
    };
    this.$refs.reportbrosablon.Print(prm).then(
      confirm => {

        this.file.push(confirm)

        var blob = new Blob([confirm], {
          type: "application/pdf"
        });

        var file = window.URL.createObjectURL(blob);
        document.querySelector("iframe1").src = file;
        this.file = blob
      },
      confirm => {
        //  this.status.loading = false;
      }
    );
  }

  function tarihkontrol(v) {

    if (v != "0001-01-01T00:00:00") {
      var parts = v.split("T");
      var parts1 = parts[0].split("-");
      return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
    } else {
      return null;
    }
  }


  function kayitcek(v) {

    var params = {
      id: v.EFaturaShowID.EFaturaID,
      guid: v.EFaturaShowID.EFaturaGuid
    }

    this.$http.post(auth.API_URL + 'api/EFatura/GetFatura', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.faturadialog = true
      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }


  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.sonucgeldi = false;
    this.FaturaInput.SirketKodu = credentials.SirketKodu;
    this.FaturaInput.FaturaGuid = this.$route.query.guid;
    var params = this.FaturaInput;
    var faturaid = null

    this.$http.post(auth.API_URL + 'api/Invoice/EInvoiceGet', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      faturaid = response.body.FaturaBilgi.EfaturaID;
      this.carikod = response.body.FaturaBilgi.FaturaMusteriKodu;
      this.unvan = response.body.FaturaBilgi.FaturaUnvani1;
      this.kredilimit = response.body.KrediLimit.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      this.email = response.body.FaturaBilgi.FaturaEMail
      this.dizayn = response.body.FaturaBilgi.FaturaPdfID; //dizaynkod;

      var editdizi = [];

      if (response.body.BiletList != null) {
        this.biletvarmi = true

        this.itemsticket = response.body.BiletList;

        this.itemsticket.forEach(element => {

          var yenikayit = [];

          yenikayit.FaturaBilgileri = element.FaturaBilgileri;
          yenikayit.GenelBilgileri = element.GenelBilgileri;

          var tarih = {
            SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
            IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
            IptalTarihi: tarihkontrol(element.TarihBilgileri.IptalTarihi)
          }

          yenikayit.TarihBilgileri = tarih;

          var fatura = {
            FaturaNo: element.FaturaBilgileri.EfaturaBilgileri.FaturaNo,
            FaturaTarihi: tarihkontrol(element.FaturaBilgileri.EfaturaBilgileri
              .GercekFaturaTarihi),
            FaturaDurumu: element.FaturaBilgileri.EfaturaBilgileri.FaturaDurumu
          }

          yenikayit.FaturaBilgileri = fatura;

          var TutarBilgileri = {
            AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
            CezaTutar: {
              CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
            },
            CharterTutar: element.TutarBilgileri.CharterTutar,
            DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
            IskontoTutar: element.TutarBilgileri.IskontoTutar,
            KaTutar: element.TutarBilgileri.KaTutar,
            NetTutar: {
              NetTutar: element.TutarBilgileri.NetTutar.NetTutar.toFixed(2).replace(
                /(\d)(?=(\d{3})+\.)/g, '$1,')
            },
            PtaTutar: element.TutarBilgileri.PtaTutar,
            ReserveTutar: element.TutarBilgileri.ReserveTutar,
            ServisTutar: {
              ServisTutar: element.TutarBilgileri.ServisTutar.ServisTutar
            },
            TaxTutar: element.TutarBilgileri.TaxTutar,
            Tutar: {
              Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2).replace(
                /(\d)(?=(\d{3})+\.)/g, '$1,')
            },
            YFFTutar: element.TutarBilgileri.YFFTutar,
            Vergiler: vergihesapla(element.TutarBilgileri),
            ServisBedeli: servishesapla(element.TutarBilgileri)
          }

          yenikayit.TutarBilgileri = TutarBilgileri;
          var OdemeBilgileri = {
            SatisSekli: odemeseklikontrol(element.OdemeBilgileri.SatisSekli)
          }
          yenikayit.OdemeBilgileri = OdemeBilgileri;
          editdizi.push(yenikayit)
        });

        this.filtreticket = editdizi;

      } else {
        this.biletvarmi = false
      }


      if (faturaid != null) {

        //efaturayı getirelim

        var params2 = {
          id: faturaid,
          guid: this.$route.query.guid
        }

        // this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params2, {
        //   headers: {
        //     'Authorization': 'Bearer ' + auth.getAuthHeader()
        //   }
        // }).then((response) => {
        //   document.getElementById("demo2").innerHTML = response.body;
        //   this.sonucgeldi = true;

        // }, (response) => {
        //   if (response.status === 0) {
        //     this.sonucgeldi = true;
        //     this.text1 = 'Service Unavailable-FaturaShow'
        //     this.snackbar = true
        //   } else {
        //     this.sonucgeldi = true;

        //     this.text1 = 'Service Unavailable-FaturaShow'
        //     this.snackbar = true
        //   }
        // })

        var prm1 = {
          id: faturaid,
          guid: this.FaturaInput.FaturaGuid
        };

        var prm = {
          SablonId: this.dizayn,
          PrintObjectName: null,
          IsTestData: false,
          Prm: prm1
        };

        this.$http.post(auth.API_URL + 'api/ReportBro/ReportBroPrintPdf', prm, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.sonucgeldi = true;

          var blob1 = new Blob([response.data], {
            type: "application/pdf"
          });
          var file1 = window.URL.createObjectURL(blob1);

          document.getElementById("denemem").src = file1;

          this.file = response

        }, (response) => {
          if (response.status === 0) {
            this.sonucgeldi = true;
            this.text1 = 'Fatura Şablonu bulunamadı'
            this.snackbar = true

          } else {
            this.sonucgeldi = true;

            this.text1 = 'Fatura Şablonu bulunamadı'
            this.snackbar = true
          }
        })


      } else {
        this.text1 = 'Faturanız getirilemedi. Lütfen tekrar deneyiniz...'
        this.snackbar = true
      }



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-EInvoiceGet'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-EInvoiceGet'
        this.snackbar = true
      }
    })

  }


  function vergihesapla(tutarlar) {

    var gosterilecektutar = 0;

    gosterilecektutar = tutarlar.AlanVergiTutar.AlanVergiTutar + tutarlar.YFFTutar.YFFTutar + tutarlar.TaxTutar.TaxTutar +
      tutarlar.KaTutar.KaTutar;
    gosterilecektutar = Math.round(gosterilecektutar * 100) / 100

    return (gosterilecektutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
  }

  function servishesapla(tutarlar) {
    var gosterilecektutar = 0;
    gosterilecektutar = tutarlar.ServisTutar.ServisTutar + tutarlar.ReserveTutar.ReserveTutar + tutarlar.DigerServisTutar
      .DigerServisTutar - tutarlar.IskontoTutar.IskontoTutar;

    gosterilecektutar = Math.round(gosterilecektutar * 100) / 100
    return (gosterilecektutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
  }


  function filtrele() {
    this.dialogfiltre = true
  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {

    this.tumsirketler = false
  }



  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }
</script>

<style>
</style>